import { brandKindCopy, type BrandKindCopy } from './brandKind';
import { useAccount } from './useAccount';

/**
 * The label table for the active brand's kind. Business copy until a brand
 * is loaded, which is also what a screen shows while it says "loading".
 */
export function useBrandCopy(): BrandKindCopy {
  const { business } = useAccount();
  return brandKindCopy(business?.kind);
}
